var _mask, _path, _mask2, _path2, _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticulate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3155_17377",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 166,
    height: 86,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 166,
    height: 86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.688 75.8974C161.92 55.8072 152.72 37.0994 137.889 23.4329C123.057 9.76642 103.661 2.12439 83.4935 2.0015C63.3261 1.87862 43.8381 9.28372 28.8413 22.7685C13.8445 36.2532 4.41768 54.8475 2.40455 74.9146L83 83L163.688 75.8974Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.688 75.8974C161.92 55.8072 152.72 37.0994 137.889 23.4329C123.057 9.76642 103.661 2.12439 83.4935 2.0015C63.3261 1.87862 43.8381 9.28372 28.8413 22.7685C13.8445 36.2532 4.41768 54.8475 2.40455 74.9146L83 83L163.688 75.8974Z",
    stroke: "#F6E003",
    strokeWidth: 4,
    mask: "url(#path-1-outside-1_3155_17377)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_3155_17377",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 80,
    width: 166,
    height: 86,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 80,
    width: 166,
    height: 86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.799 88.7097C162.376 108.836 153.494 127.707 138.889 141.629C124.285 155.551 105.011 163.521 84.8392 163.979C64.6677 164.437 45.0514 157.351 29.8301 144.106C14.6089 130.862 4.8786 112.413 2.54403 92.3722L83 83L163.799 88.7097Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.799 88.7097C162.376 108.836 153.494 127.707 138.889 141.629C124.285 155.551 105.011 163.521 84.8392 163.979C64.6677 164.437 45.0514 157.351 29.8301 144.106C14.6089 130.862 4.8786 112.413 2.54403 92.3722L83 83L163.799 88.7097Z",
    stroke: "#3D3D3D",
    strokeWidth: 4,
    strokeDasharray: "2 4",
    mask: "url(#path-2-outside-2_3155_17377)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83,
    r: 81,
    fill: "#1D1D1D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83,
    r: 70,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3155_17377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3599 73.48C55.6699 79.36 61.4899 83.06 67.3699 81.75C71.4999 80.83 74.7199 77.61 75.6399 73.48C76.4699 73.01 76.9899 72.14 76.9999 71.18V70.09C77.0499 69.36 76.6499 68.67 75.9999 68.34V67C75.9199 60.96 71.0399 56.08 64.9999 56C59.0599 56.08 54.2199 60.81 53.9999 66.75C53.9999 66.75 53.9999 66.78 53.9999 66.8V68.31C53.3499 68.64 52.9599 69.33 52.9999 70.06V71.15C52.9999 72.12 53.5199 73.01 54.3599 73.48ZM74.9999 70.09V71.18C74.9999 71.47 74.7999 71.73 74.5099 71.79C74.1199 71.89 73.8299 72.21 73.7699 72.6C72.9299 77.44 68.3299 80.69 63.4799 79.85C59.7699 79.21 56.8699 76.3 56.2299 72.6C56.1699 72.21 55.8799 71.89 55.4899 71.79C55.1999 71.73 54.9999 71.47 54.9999 71.18V70.07L55.3199 69.94C55.7199 69.8 55.9999 69.43 55.9999 69V67.94C56.5899 67.98 57.1599 68 57.7099 68C60.0199 68.08 62.3299 67.63 64.4399 66.68C65.3499 66.21 66.2199 65.67 67.0499 65.07L67.8199 64.55C67.4099 65.48 67.6299 66.56 68.3699 67.25C69.3099 68.01 71.0699 68.08 73.9999 67.47V69C73.9999 69.42 74.2699 69.8 74.6699 69.94L74.9999 70.07V70.09ZM64.9999 58C69.3499 58.06 73.0499 61.18 73.8499 65.46C70.4099 66.21 69.6999 65.76 69.6499 65.71C69.6599 65.33 69.7499 64.96 69.8999 64.61C70.1299 63.97 70.6099 62.61 69.3799 62.11C68.3799 61.71 67.3799 62.43 65.9199 63.42C65.1699 63.96 64.3799 64.45 63.5599 64.88C61.1899 65.86 58.6199 66.23 56.0699 65.94C56.6599 61.44 60.4599 58.06 64.9999 58Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.46 53H84.5405C83.1405 53 82.0005 54.14 82.0005 55.54V69.71L77.1505 77.47C76.9205 77.85 76.9605 78.33 77.2505 78.66C77.4405 78.88 77.7105 79 78.0005 79C78.1405 79 78.2905 78.97 78.4205 78.91L91.2205 73H110.46C111.86 73 113 71.86 113 70.46V55.54C113 54.14 111.86 53 110.46 53ZM111 70.46C111 70.76 110.76 71 110.46 71H91.0005C90.8605 71 90.7105 71.03 90.5805 71.09L80.6305 75.69L83.8505 70.53C83.9505 70.37 84.0005 70.19 84.0005 70V55.54C84.0005 55.24 84.2405 55 84.5405 55H110.46C110.76 55 111 55.24 111 55.54V70.46Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 99.34V98C112.07 91.92 107.2 86.94 101.12 86.88C95.0403 86.82 90.0603 91.68 90.0003 97.76V99.27C89.3503 99.6 88.9503 100.29 89.0003 101.02V102.11C89.0003 103.07 89.5303 103.94 90.3603 104.41C91.6703 110.29 97.4903 113.99 103.37 112.68C107.5 111.76 110.72 108.54 111.64 104.41C112.45 103.96 112.97 103.12 113 102.19V101.1C113.05 100.37 112.65 99.68 112 99.35V99.34ZM101 89C105.35 89.06 109.05 92.18 109.85 96.46C106.41 97.21 105.7 96.75 105.65 96.71C105.66 96.33 105.75 95.96 105.9 95.61C106.13 94.97 106.61 93.61 105.38 93.11C104.38 92.71 103.38 93.43 101.92 94.42C101.17 94.96 100.38 95.45 99.5603 95.88C97.1903 96.86 94.6203 97.23 92.0703 96.94C92.6603 92.44 96.4603 89.06 101 89ZM111 101.09V102.18C111 102.47 110.8 102.73 110.51 102.79C110.12 102.89 109.83 103.21 109.77 103.6C108.93 108.44 104.33 111.69 99.4803 110.85C95.7703 110.21 92.8703 107.3 92.2303 103.6C92.1703 103.21 91.8803 102.89 91.4903 102.79C91.2003 102.73 91.0003 102.47 91.0003 102.18V101.07L91.3203 100.94C91.7203 100.8 92.0003 100.43 92.0003 100V98.94C92.5903 98.98 93.1603 99 93.7103 99C96.0203 99.08 98.3303 98.63 100.44 97.68C101.35 97.21 102.22 96.67 103.05 96.07L103.82 95.55C103.41 96.48 103.63 97.56 104.37 98.25C105.31 99.01 107.07 99.08 110 98.47V100C110 100.42 110.27 100.8 110.67 100.94L111 101.07V101.09Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58 109.91C87.71 109.97 87.86 110 88 110C88.29 110 88.56 109.88 88.75 109.66C89.04 109.33 89.08 108.85 88.85 108.47L84 100.71V86.54C84 85.14 82.86 84 81.46 84H55.54C54.14 84 53 85.14 53 86.54V101.46C53 102.86 54.14 104 55.54 104H74.78L87.58 109.91ZM55 101.46V86.54C55 86.24 55.24 86 55.54 86H81.46C81.76 86 82 86.24 82 86.54V101C82 101.19 82.05 101.37 82.15 101.53L85.38 106.69L75.38 102.09C75.26 102.04 75.13 102 75 102H55.54C55.24 102 55 101.76 55 101.46Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 57H87C86.45 57 86 57.45 86 58C86 58.55 86.45 59 87 59H90C90.55 59 91 58.55 91 58C91 57.45 90.55 57 90 57Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 57H94C93.45 57 93 57.45 93 58C93 58.55 93.45 59 94 59H108C108.55 59 109 58.55 109 58C109 57.45 108.55 57 108 57Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 62H87C86.45 62 86 62.45 86 63C86 63.55 86.45 64 87 64H90C90.55 64 91 63.55 91 63C91 62.45 90.55 62 90 62Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 62H94C93.45 62 93 62.45 93 63C93 63.55 93.45 64 94 64H108C108.55 64 109 63.55 109 63C109 62.45 108.55 62 108 62Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 67H87C86.45 67 86 67.45 86 68C86 68.55 86.45 69 87 69H90C90.55 69 91 68.55 91 68C91 67.45 90.55 67 90 67Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 67H94C93.45 67 93 67.45 93 68C93 68.55 93.45 69 94 69H108C108.55 69 109 68.55 109 68C109 67.45 108.55 67 108 67Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1796 88.43L66.8596 97.43L63.7096 94.27C63.3196 93.88 62.6796 93.88 62.2896 94.27C61.8996 94.66 61.8996 95.3 62.2896 95.69L66.2896 99.69C66.4796 99.88 66.7296 100 66.9996 100H67.0896C67.3896 99.97 67.6496 99.81 67.8196 99.57L74.8196 89.57C75.1596 89.13 75.0796 88.51 74.6396 88.17C74.1996 87.83 73.5796 87.91 73.2396 88.35C73.2196 88.38 73.1996 88.41 73.1796 88.44V88.43Z",
    fill: "#F6E003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3155_17377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.01,
    height: 59.94,
    fill: "white",
    transform: "translate(53 53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticulate);
export default __webpack_public_path__ + "static/media/Articulate.681c013ae7e562edc2a35d73b552205c.svg";
export { ForwardRef as ReactComponent };